/*
 * @description: 订单联系人
 */
import { useState, useCallback } from 'react';

export default function OrderCenterSameCityOrderContact() {
  // 订单联系号码
  const [contactPhoneNo, setContactPhoneNo] = useState<string>('');

  const reset = useCallback(() => {
    setContactPhoneNo('');
  }, []);
  const set = useCallback((val) => {
    setContactPhoneNo(val);
  }, []);

  return {
    contactPhoneNo,
    setContactPhoneNo,
    reset,
    set,
  };
}
